import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: () => import('@/layout'),
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: {
      noCache: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: { title: 'home', icon: 'home', affix: true }
    },
    {
      path: 'profile',
      name: 'profile',
      hidden: true,
      component: () => import('@/views/home/profile'),
      meta: { title: 'profile', icon: 'profile', affix: false }
    }
    ]
  },
  {
    path: '/dataCenter',
    component: () => import('@/views/dataCenter/index'),
    hidden: true
  },
]

export const page404Routes = {
  parentId: "0",
  title: "404",
  type: 1,
  path: "*",
  redirect: "/404",
  affix: 1,
  noCahche: 1,
  hidden: 2,
  orderNum: 99999
}

const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// 防止重复添加路由
router.$addRoutes = (params) => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher;
  router.addRoutes(params)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js